import { useEffect, useState } from 'react';
import { LeaveRequestApi } from '../../../api';
import { dispatch } from '../../../store';
import { addProfileOngoingLeaveRequests } from '../../../store/slices/user-profile.slice';
import { useContainer } from '../../useContainer';

const useHttpGetOngoingLeaveRequestsByUserSubOnMount = (userSub: string) => {
    const leaveRequestApi = useContainer(LeaveRequestApi);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = leaveRequestApi.getOngoingLeaveRequestsForUserProfile({
        params: { userSub },
        onSuccess: res => {
            dispatch(addProfileOngoingLeaveRequests(res.body));
        },
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { exec, isReady };
};

export default useHttpGetOngoingLeaveRequestsByUserSubOnMount;
